import { useState, useEffect, cloneElement } from 'react';
import styles from './toggle-box.module.scss';
import { Toggle } from '../../Toggle';
import { IToggleBox } from '../../../types/Toggle/toggle_box/toggleBox';

export const ToggleBox = ({
    size = "md",
    color = "default",
    text,
    hintText,
    type,
    icon, // 'type' must be 'bordered box' to render this icon
    checked = false,
    disabled = false,
    onToggleChangeHandler,
    onBeforeToggleConfirmation
}: IToggleBox) => {

    const [isToggleBoxHovered, setIsToggleBoxHovered] = useState(false);
    const [isToggleBoxFocused, setIsToggleBoxFocused] = useState(false);
    const [isToggleBoxChecked, setIsToggleBoxChecked] = useState(checked);

    useEffect(() => {
        setIsToggleBoxChecked(checked);
    }, [checked]);

    const onMouseOverHandler = () => {
        !disabled && setIsToggleBoxHovered(true);
    };

    const onMouseOutHandler = () => {
        !disabled && setIsToggleBoxHovered(false);
    };

    const onFocusHandler = () => {
        !disabled && setIsToggleBoxFocused(true);
    };

    const onBlurHandler = () => {
        !disabled && setIsToggleBoxFocused(false);
    };

    const onClickHandler = async (e: any) => {
        // in-case of the "type" is "bordered box" or "transparent box" 
        // we check that the target element is not the child toggle to prevent firing the action twice
        if (e.target.id !== 'toggle-base' && e.target.id !== 'toggle-base-slider' && !disabled) {


            if (onBeforeToggleConfirmation) {
                const shouldToggle = await onBeforeToggleConfirmation(isToggleBoxChecked);
                if (shouldToggle) {
                    setIsToggleBoxChecked(!isToggleBoxChecked);
                }
            } else {
                setIsToggleBoxChecked(!isToggleBoxChecked);
            }

        }
    };

    return (
        <div
            className={styles['toggle-box']}
            data-toggle-box-size={size}
            data-toggle-box-color={color}
            data-toggle-box-disabled={disabled}
            data-toggle-box-hovered={isToggleBoxHovered}
            data-toggle-box-focused={isToggleBoxFocused}
            data-toggle-box-type={type}
            onClick={onClickHandler}
            onMouseOver={onMouseOverHandler}
            onMouseOut={onMouseOutHandler}
            onFocusCapture={onFocusHandler}
            onBlurCapture={onBlurHandler}
            tabIndex={0}
        >

            {
                cloneElement(
                    <Toggle
                        size={size}
                        color={color}
                        disabled={disabled}
                        checked={isToggleBoxChecked}
                        onChangeHandler={onToggleChangeHandler}
                        onBeforeToggleConfirmation={onBeforeToggleConfirmation}
                    />, { hovered: isToggleBoxHovered, focused: isToggleBoxFocused }
                )
            }

            {
                (text || hintText) &&
                <div className={styles['toggle-box__text-box']}>
                    {text && <div className={styles['toggle-box__text-box__text']}>{text}</div>}
                    {hintText && <div className={styles['toggle-box__text-box__hint-text']}>{hintText}</div>}
                </div>
            }

            {
                (icon && type === 'bordered box') &&
                <div className={styles['toggle-box__icon']}>
                    {icon}
                </div>
            }
        </div>
    )
}